import React from "react";
import api from "../../api";
import { useEffect, useState } from "react";
import ProfileCard from "./ProfileCard";
import { Auth } from "aws-amplify";

const ProfileMain = () => {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState([]);
  const [error, setError] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  });

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      setLoading(true);
      const { data: responseData } = await api.get(`/profiles?`, {
        params: {
          register_status: "P",
        },
      });
      console.log("responseData", responseData);
      setProfile(responseData?.profiles);
    } catch (error) {
      console.log("ERROR TO LOAD PROFILE :", error);
    } finally {
      setLoading(false);
    }
  };
  const onChangeForm = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const onClickSubmit = async () => {
    try {
      setSubmit(true);
      if (!form.firstname || !form.lastname || !form.email || !form.password) {
        return setError(true);
      }

      setLoading(true);

      await Auth.signUp({
        username: form.email,
        password: form.password,
        email: form.email,
      });
      await api.post("/profiles", {
        ...form,
        register_status: "S",
      });
      alert("สร้างผู้ใช้งานแล้ว");
    } catch (error) {
    } finally {
      setLoading(false);
      setForm("");
    }
  };

  if (loading) {
    return <div>Loading....</div>;
  }

  return (
    <div className="pl-72 mb-10">
      <div className=" mt-20 text-xl font-bold text-orange-600">
        รวม Account ที่สมัครสมาชิก
      </div>
      <div className="grid grid-cols-3 ">
        {profile?.map((profile, index) => {
          return (
            <ProfileCard
              loadProfile={loadProfile}
              key={index}
              profile={profile}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProfileMain;
